"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDefaultLabelPoint = function (start, end, marginPX) {
    var dy = end.y - start.y;
    var dx = end.x - start.x;
    var slope = dy / dx;
    var centerX = (start.x + end.x) / 2;
    var centerY = (start.y + end.y) / 2;
    // if line is horizontal, slope is 0
    if (slope === 0) {
        return { x: centerX, y: (centerY + marginPX) };
    }
    // NOTE(jeffk): centerX +/- ... are both solutions, but we use -
    var labelX = centerX - Math.sqrt((Math.pow(marginPX, 2) / (1 + (1 / Math.pow(slope, 2)))));
    var labelY = -(1 / slope) * (labelX - centerX) + centerY;
    return { x: labelX, y: labelY };
};
exports.percentToCoordinate = function (point, canvasWidth, canvasHeight) {
    var x = point.xPercent * canvasWidth / 100;
    var y = point.yPercent * canvasHeight / 100;
    return { x: x, y: y };
};
exports.coordinateToPercent = function (point, canvasWidth, canvasHeight) {
    var xPercent = point.x / canvasWidth * 100;
    var yPercent = point.y / canvasHeight * 100;
    return { xPercent: xPercent, yPercent: yPercent };
};
